<template>
  <div class="a-promo-code promo-code">
    <template v-if="!isCouponCode">
      <div class="promo-code__form" v-if="addCouponPressed">
        <SfInput
          v-model="promoCode"
          name="promoCode"
          :label="$t('Discount code')"
          class="sf-input--filled promo-code__input"
          @keyup.enter="setCouponCode"
        />
        <SfCircleIcon
          class="promo-code__circle-icon"
          icon="check"
          @click="setCouponCode"
        />
      </div>
      <div class="promo-code__link-container" v-else>
        {{ $t('Aktionscode oder Gutschein?') }}
        <SfLink
          class="promo-code__link"
          @click.native.prevent="addCouponPressed = true"
        >
          {{ $t('Hier einlösen') }}
        </SfLink>
      </div>
    </template>
    <div
      v-else-if="allowPromoCodeRemoval"
      class="promo-code__link-container"
    >
      <SfLink
        class="promo-code__link"
        @click="removeCoupon"
      >
        {{ $t("Delete discount code") }}
      </SfLink>
    </div>
  </div>
</template>

<script>
import { SfInput, SfButton, SfCircleIcon, SfLink } from '@storefront-ui/vue';
import i18n from '@vue-storefront/i18n'

export default {
  name: 'APromoCode',
  components: {
    SfInput,
    SfButton,
    SfCircleIcon,
    SfLink
  },
  props: {
    allowPromoCodeRemoval: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      promoCode: '',
      addCouponPressed: false
    };
  },
  computed: {
    isCouponCode () {
      return this.$store.state.cart.platformTotals ? this.$store.state.cart.platformTotals.coupon_code : false;
    }
  },
  methods: {
    async applyCoupon () {
      return this.$store.dispatch('cart/applyCoupon', this.promoCode);
    },
    async setCouponCode () {
      await this.applyCoupon()
      this.addCouponPressed = false
      this.promoCode = ''
    },
    removeCoupon () {
      this.$store.dispatch('cart/removeCoupon');
    }
  }
};
</script>
<style lang="scss" scoped>
.promo-code {

  &__form {
    display:flex;
    align-items:baseline;
  }
  &__link-container {
    display: block;
    text-align:end;
  }

  padding: var(--spacer-lg) 0 var(--spacer-lg);
  &__circle-icon {
    --button-size: 2rem;
    --icon-size: 0.6875rem;
  }
  &__input {
    --input-background: var(--c-white);
    flex: 1;
    margin: 0 var(--spacer-lg) 0 0;
  }
  &__button {
    --button-height: 2rem;
    --button-font-size: 0.6875rem;
  }
}
</style>
